import {
  INCOMING_MAPPING_HEADERS_RECEIVED,
  INCOMING_MAPPING_UPDATED,
} from './actions'

import { APP_STATE } from '../../../constants'

export const initialState = {
  stateOfAction: APP_STATE.FETCHING,
  incomingMapping: undefined,
  headers: undefined,
  errorMsg: '',
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case APP_STATE.FETCHING:
      return {
        ...state,
        stateOfAction: APP_STATE.FETCHING,
      }

    case APP_STATE.ERROR:
      return {
        ...state,
        stateOfAction: APP_STATE.ERROR,
        errorMsg: action.msg,
      }

    case APP_STATE.DONE:
      return {
        ...state,
        stateOfAction: APP_STATE.DONE,
      }

    case INCOMING_MAPPING_HEADERS_RECEIVED:
      return {
        ...state,
        incomingMapping: action.mapping,
        headers: action.headers,
        stateOfAction: APP_STATE.DONE,
      }

    case INCOMING_MAPPING_UPDATED:
      return {
        ...state,
        incomingMapping: action.mapping,
        stateOfAction: APP_STATE.DONE,
      }

    default:
      return state
  }
}
